import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { faqItems } from '../../data/faq';
import { ChevronDown } from 'lucide-react';

export const FAQ: React.FC = () => {
  const [openItem, setOpenItem] = React.useState<string | null>(null);

  return (
    <section id="faq" className="py-24 bg-white relative overflow-hidden">
      {/* Rest of the component remains the same */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 right-0 w-64 h-64 bg-red-600 rounded-full translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-green-600 rounded-full -translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-4">
            Frequently Asked Questions ❓🎄
          </h2>
          <p className="text-xl text-gray-600">
            Got questions? We've got answers! Here's everything you need to know about creating your magical Santa videos.
          </p>
        </motion.div>

        <div className="space-y-4">
          {faqItems.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="border border-gray-200 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenItem(openItem === item.id ? null : item.id)}
                className="w-full px-6 py-4 flex items-center justify-between bg-white hover:bg-gray-50 transition-colors"
              >
                <span className="flex items-center text-lg font-semibold text-gray-900">
                  <span className="mr-3 text-2xl">{item.icon}</span>
                  {item.question}
                </span>
                <ChevronDown
                  className={`w-5 h-5 text-gray-500 transition-transform ${
                    openItem === item.id ? 'transform rotate-180' : ''
                  }`}
                />
              </button>
              <AnimatePresence>
                {openItem === item.id && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="px-6 py-4 bg-gray-50 text-gray-600">
                      {item.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="mt-12 text-center p-6 bg-red-50 rounded-xl border border-red-100"
        >
          <p className="text-lg text-red-800">
            Still have questions? Contact us at support@santamagic.ai or click here to chat with our holiday support elves! 🎅✨
          </p>
        </motion.div>
      </div>
    </section>
  );
};